module.exports = __webpack_public_path__ + "static/media/dial_iterations.7d179786.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/dial_iterations.JPG
// module id = 71
// module chunks = 0